
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43.548 14.633"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 8296"}},[_c('g',{attrs:{"data-name":"Group 8295"}},[_c('text',{attrs:{"transform":"translate(0 11.5)","fill":"#74ce00","font-size":"11","font-family":"Montserrat-Medium, Montserrat","font-weight":"500"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('PDF')])]),_c('g',{attrs:{"data-name":"Group 7647","fill":"none","stroke":"#74ce00","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"data-name":"Group 8294"}},[_c('path',{attrs:{"data-name":"Line 56","d":"M40 8.501l-3 3"}}),_c('path',{attrs:{"data-name":"Line 57","d":"M34 8.501l3 3"}})]),_c('path',{attrs:{"data-name":"Path 11171","d":"M43.048 10.647v2.905a.586.586 0 01-.581.581H30.832a.575.575 0 01-.568-.581v-2.905"}}),_c('path',{attrs:{"data-name":"Line 58","d":"M37 .5v11"}})])])])])
          )
        }
      }
    